// Generated by Melange

import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(page) {
  return function (setPage) {
    return function (currentRecords) {
      return function (className) {
        const startCount = Math.imul(25, page - 1 | 0) + (
          currentRecords > 0 ? 1 : 0
        ) | 0;
        const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
        const deviceType = state.deviceType;
        const count = Math.imul(25, page - 1 | 0) + currentRecords | 0;
        return JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            deviceType === "mobile" ? JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "w-5 h-5",
                                          src: StaticAsset.src("/static/icons/back-arrow-black.svg")
                                        }),
                                    className: "lg:ml-4",
                                    onClick: (function (param) {
                                        if (page > 1) {
                                          return Curry._1(setPage, (function (param) {
                                                        return page - 1 | 0;
                                                      }));
                                        }
                                        
                                      })
                                  }) : null,
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                  children: String(startCount) + ("-" + (String(count) + (" из " + String(count))))
                                }),
                            deviceType !== "mobile" ? JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "w-5 h-5",
                                          src: StaticAsset.src("/static/icons/back-arrow-black.svg")
                                        }),
                                    className: "lg:ml-4",
                                    onClick: (function (param) {
                                        if (page > 1) {
                                          return Curry._1(setPage, (function (param) {
                                                        return page - 1 | 0;
                                                      }));
                                        }
                                        
                                      })
                                  }) : null,
                            JsxRuntime.jsx("button", {
                                  children: JsxRuntime.jsx("img", {
                                        className: "w-5 h-5 rotate-180",
                                        src: StaticAsset.src("/static/icons/back-arrow-black.svg")
                                      }),
                                  className: "lg:ml-2",
                                  onClick: (function (param) {
                                      if (currentRecords >= 25) {
                                        return Curry._1(setPage, (function (param) {
                                                      return page + 1 | 0;
                                                    }));
                                      }
                                      
                                    })
                                })
                          ],
                          className: "flex w-full justify-between lg:justify-end items-center"
                        }),
                    className: Cn.$plus("flex justify-center lg:justify-end lg:px-6 p-4 border-t border-gray-main bg-gray-pale lg:bg-white", Cn.take(className))
                  });
      };
    };
  };
}

function PageNav(Props) {
  return Curry._2(make(Props.page)(Props.setPage), Props.currentRecords, Props.className);
}

const make$1 = PageNav;

export {
  make$1 as make,
}
/* Buhta_components__Text Not a pure module */
